import AnnualDataQualityMeasurementIntegrity from "./AnnualDataQualityMeasurementIntegrity";

const AnnualServicePerformanceComplexity = (props) => (
  <AnnualDataQualityMeasurementIntegrity
    {...props}
    title="Annual Department/Service Performance and Complexity"
    description="Annual service complexity envelope covering demand share, workload, duration variance, wait percentiles, outcomes, and SLA target confidence."
    emptyTableText="No annual service complexity tables were supplied."
  />
);

export default AnnualServicePerformanceComplexity;
